module.exports = __webpack_public_path__ + "static/img/5.9957e93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/5.png
// module id = vNRz
// module chunks = 0